/**
 * Make product-scoped third-party content inherit from the MSKU parent product.
 *
 * This file is loaded before Shopify's app scripts. Judge.me is rendered with the
 * parent product in Liquid; this interceptor handles Mintt Instafeed, whose
 * product-page feed is selected by the `handle` query parameter.
 */
(function () {
  'use strict';

  var config = window.SicotasSharedProductApps;
  if (!config || !config.currentHandle || !config.sourceHandle) return;
  if (config.currentHandle === config.sourceHandle) return;

  function rewriteInstafeedUrl(value) {
    if (!value) return value;

    var url;
    try {
      url = new URL(String(value), window.location.href);
    } catch (_error) {
      return value;
    }

    if (url.hostname !== 'nfcube.com' && !url.hostname.endsWith('.nfcube.com')) return value;
    if (url.pathname.indexOf('/feed') !== 0) return value;

    // Product-page feeds use this handle to filter tagged photos and videos.
    // Always set it so a child page cannot fall back to its own product context.
    url.searchParams.set('handle', config.sourceHandle);
    return url.href;
  }

  config.rewriteInstafeedUrl = rewriteInstafeedUrl;

  var nativeFetch = window.fetch;
  if (nativeFetch && !nativeFetch.__sicotasSharedProductApps) {
    var sharedProductFetch = function (input, init) {
      if (typeof input === 'string' || input instanceof URL) {
        return nativeFetch.call(this, rewriteInstafeedUrl(input), init);
      }

      if (typeof Request !== 'undefined' && input instanceof Request) {
        var rewrittenUrl = rewriteInstafeedUrl(input.url);
        if (rewrittenUrl !== input.url) {
          input = new Request(rewrittenUrl, input);
        }
      }

      return nativeFetch.call(this, input, init);
    };

    sharedProductFetch.__sicotasSharedProductApps = true;
    window.fetch = sharedProductFetch;
  }

  var xhrPrototype = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
  if (xhrPrototype && !xhrPrototype.open.__sicotasSharedProductApps) {
    var nativeOpen = xhrPrototype.open;
    var sharedProductOpen = function (method, url) {
      var args = Array.prototype.slice.call(arguments);
      args[1] = rewriteInstafeedUrl(url);
      return nativeOpen.apply(this, args);
    };

    sharedProductOpen.__sicotasSharedProductApps = true;
    xhrPrototype.open = sharedProductOpen;
  }

  // Some Instafeed releases load the feed as a dynamic script instead of using
  // fetch/XHR. Rewrite resource URLs before the browser starts those requests.
  function rewriteResourceElement(element) {
    if (!element || element.nodeType !== 1) return;

    ['src', 'href'].forEach(function (attribute) {
      if (!element.hasAttribute || !element.hasAttribute(attribute)) return;
      var currentValue = element.getAttribute(attribute);
      var rewrittenValue = rewriteInstafeedUrl(currentValue);
      if (rewrittenValue !== currentValue) {
        element.setAttribute(attribute, rewrittenValue);
      }
    });
  }

  var nativeAppendChild = Node.prototype.appendChild;
  Node.prototype.appendChild = function (child) {
    rewriteResourceElement(child);
    return nativeAppendChild.call(this, child);
  };

  var nativeInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    rewriteResourceElement(newNode);
    return nativeInsertBefore.call(this, newNode, referenceNode);
  };

  var nativeReplaceChild = Node.prototype.replaceChild;
  Node.prototype.replaceChild = function (newChild, oldChild) {
    rewriteResourceElement(newChild);
    return nativeReplaceChild.call(this, newChild, oldChild);
  };

  var nativeSetAttribute = Element.prototype.setAttribute;
  Element.prototype.setAttribute = function (name, value) {
    if (name === 'src' || name === 'href') {
      value = rewriteInstafeedUrl(value);
    }
    return nativeSetAttribute.call(this, name, value);
  };

  var scriptSrcDescriptor = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, 'src');
  if (scriptSrcDescriptor && scriptSrcDescriptor.set) {
    Object.defineProperty(HTMLScriptElement.prototype, 'src', {
      configurable: scriptSrcDescriptor.configurable,
      enumerable: scriptSrcDescriptor.enumerable,
      get: scriptSrcDescriptor.get,
      set: function (value) {
        scriptSrcDescriptor.set.call(this, rewriteInstafeedUrl(value));
      }
    });
  }
})();
